import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { useTheme } from 'emotion-theming'
import { makeImgResizerUrl } from '@jelly/utils'
import { shape, string } from 'prop-types'
import { SiteConfigContext } from '../SiteConfigProvider'

MetaData.propTypes = {
	meta: shape({
		canonical: string,
		description: string,
		ogImage: string,
		robots: string,
		title: string,
	}),
}

export function MetaData({ meta: { canonical, description, ogImage, robots, title } }) {
	const {
		siteConstants: { META_DATA },
	} = useContext(SiteConfigContext)
	const {
		colors: { primary },
	} = useTheme()

	const applicationName = META_DATA.applicationName
	const twitterName = META_DATA.twitterName
	robots = robots || META_DATA.robots
	title = title || META_DATA.title

	const resizedImage = makeImgResizerUrl({ src: ogImage ? ogImage : META_DATA.ogImage, method: 'w', w: '700' })

	return (
		<Helmet htmlAttributes={{ lang: 'en' }}>
			<meta charset="utf-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
			<title>{title}</title>
			<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
			<meta name="title" content={title} />
			{description && <meta name="description" content={description} />}
			{robots && <meta name="robots" content={robots} />}

			<meta name="mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-capable" content="yes" />
			<meta name="application-name" content={applicationName} />
			<meta name="apple-mobile-web-app-title" content={applicationName} />
			<meta name="theme-color" content={primary} />
			<meta name="msapplication-navbutton-color" content={primary} />
			<meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
			<meta name="msapplication-starturl" content="/" />

			<meta property="og:title" content={title} />
			{description && <meta property="og:description" content={description} />}
			<meta property="og:site_name" content={applicationName} />
			{canonical && <meta property="og:url" content={canonical} />}
			<meta property="og:image" content={resizedImage} />
			<meta property="og:type" content="article" />

			<meta name="twitter:card" content="summary" />
			<meta name="twitter:site" content={twitterName} />
			<meta name="twitter:creator" content={twitterName} />
			<meta name="twitter:title" content={title} />
			{description && <meta name="twitter:description" content={description} />}
			<meta name="twitter:image" content={resizedImage} />
			{canonical && <link rel="canonical" href={canonical} />}
			<link rel="manifest" href="/manifest.webmanifest" />
		</Helmet>
	)
}
